import { render, staticRenderFns } from "./BetslipEmpty.vue?vue&type=template&id=0fc9448d&scoped=true"
import script from "./BetslipEmpty.vue?vue&type=script&lang=js"
export * from "./BetslipEmpty.vue?vue&type=script&lang=js"
import style0 from "./BetslipEmpty.vue?vue&type=style&index=0&id=0fc9448d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc9448d",
  null
  
)

export default component.exports